<template>
  <section class="beneficios">
    <DsChip label="Tus beneficios" variant="orange" />

    <div class="beneficios__title">
      <DsTextSplit
            as="h4"
            base="Aprovecha los"
            highlight="beneficios disponibles"
            baseColor="var(--ds-purple-900)"
            highlightColor="#6D59EA"
          />
    </div>

    <DsText as="body3" class="beneficios__intro">Puedes obtener descuentos acumulables:</DsText>

    <div class="beneficios_card_image">
        <picture class="beneficios_image">
          <source :srcset="advanceTabletImage" media="(min-width: 1024px)">
          <source :srcset="advanceMobileImage" media="(min-width: 768px)">
          <img
            :src="advanceDesktopImage"
            alt="img_bienvenida_benefits"
            class="beneficios__image"
          >
        </picture>
        <div class="beneficios__overlay" />
        <div class="beneficios__cards">
          <article v-for="item in items" :key="item.title" class="beneficios__discount">
            <DsText as="h3" color="var(--ds-secondary-main)">{{ item.percent }}</DsText>
            <DsText as="body3" class="beneficios__discount-copy">{{ item.title }}</DsText>
          </article>
        </div>
      </div>
  </section>
</template>

<script setup lang="ts">
import DsChip from '../atoms/DsChip.vue'
import DsText from '../atoms/DsText.vue'
import DsTextSplit from '../atoms/DsTextSplit.vue'
import advanceMobileImage from '../../../assets/bienvenida-mobile/beneficios.png'
import advanceTabletImage from '../../../assets/bienvenida_benefi.webp'
import advanceDesktopImage from '../../../assets/bienvenida-desktop-beneficios.png'

const items = [
  { percent: '5%', title: 'Por domiciliar tus pagos' },
  { percent: '5%', title: 'Por pago puntual' },
  { percent: '5%', title: 'Por referir a alguien' },
]
</script>

<style scoped>
.beneficios {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.beneficios__title {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.beneficios__intro {
  color: var(--ds-text-primary);
  line-height: 1.5;
}

.beneficios_card_image{
  position: relative;
  width: 100%;
  border-radius: 28px;
  overflow: hidden;
  background: #000000;
  width: 100%;
  height: 562px;
}

.beneficios_image {
  width: 100%;
  display: block;
}

.beneficios__image{
  display: block;
  width: 100%;
  height: auto;
  border-radius: 28px;
}


.beneficios__overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
}

.beneficios__cards {
  position: absolute;
  top: 52px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 240px);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  z-index: 2;
  opacity: 80%;
}

.beneficios__discount {
  min-height: 146px;
  border-radius: 28px;
  background: #f4d5c3;
  padding: 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
  max-width: 260px;
  opacity: 80%;
}

.beneficios__discount-copy {
  color: var(--ds-text-primary);
  line-height: 1.25;
  max-width: 200px;
}

@media (max-width: 1024px) {
  .beneficios__cards {
    grid-template-columns: 1fr;
    padding-top: 32px;
    justify-self: center;
    opacity: 80%;
  }

  .beneficios__discount {
    opacity: 80%;
  }
}

@media (min-width: 1025px) {
  .beneficios { gap: 24px; }
  .beneficios_card_image { height: 568px; border-radius: 24px; }
  .beneficios_image,
  .beneficios__image { width: 100%; height: 100%; object-fit: cover; border-radius: 24px; }
  .beneficios__cards { top: 40px; width: 714px; gap: 24px; opacity: 1; }
  .beneficios__discount {
    width: 222px;
    height: 120px;
    min-height: 120px;
    border-radius: 24px;
    padding: 16px;
    gap: 8px;
    background: rgba(255, 244, 232, 0.8);
  }
}

@media (max-width: 768px) {
  .beneficios { gap: 24px; }
  .beneficios__image-wrap {
    min-height: 700px;
    border-radius: 24px;
  }

  .beneficios__cards {
    grid-template-columns: 1fr;
    top: 40px;
    width: 222px;
    padding: 0;
    gap: 24px;
    justify-items: start;
    opacity: 1;
  }

  .beneficios_card_image {
    height: 568px;
    border-radius: 24px;
  }

  .beneficios_image { position: absolute; inset: 0; height: 100%; }
  .beneficios__image {
    position: absolute;
    top: 0;
    left: -0.01%;
    width: 307.69%;
    max-width: none;
    height: 100%;
    border-radius: 24px;
  }

  .beneficios__discount {
    width: 222px;
    max-width: 222px;
    min-height: 120px;
    height: 120px;
    border-radius: 24px;
    padding: 16px;
    gap: 8px;
    align-items: flex-start;
    background: rgba(255, 244, 232, 0.8);
  }

  .beneficios__discount-copy {
    max-width: none;
  }

}
</style>
